import type { CoupleFeedbackSentiment } from '@lib/enums/couple-feedback-sentiment.enum'
import type { CoupleFeedbackStatus } from '@lib/enums/couple-feedback-status.enum'
import type { BadgeTone } from '@/components/ui/badge'

/** "1 guest", or a grouped count: "100,000,000 guests". */
export function guestCountLine(count: number): string {
  if (count === 1) return '1 guest'
  return `${count.toLocaleString('en-US')} guests`
}

/** The two answers, in the words the couple chose. */
export const SENTIMENT_TITLE: Record<CoupleFeedbackSentiment, string> = {
  needs_attention: 'Something needs attention',
  wonderful: 'It was wonderful',
}

/** Where an answer sits for the venue. */
export const STATUS_LABEL: Record<CoupleFeedbackStatus, string> = {
  new: 'New',
  in_progress: 'In progress',
  resolved: 'Resolved',
  noted: 'Noted',
}

export const STATUS_TONE: Record<CoupleFeedbackStatus, BadgeTone> = {
  new: 'warning',
  in_progress: 'info',
  resolved: 'success',
  noted: 'neutral',
}
